import i18n from "i18next";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export const daysEn = [
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
  "SUNDAY",
];

export const daysEs = ["LUNES", "MARTES", "MIÉRCOLES", "JUEVES", "VIERNES", "SÁBADO", "DOMINGO"];

export const monthsEs = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

export const getTranslatedDays = () => [
  { label: i18n.t("advanced-search.classroom.forms.days.monday"), value: daysEn[0] },
  { label: i18n.t("advanced-search.classroom.forms.days.tuesday"), value: daysEn[1] },
  { label: i18n.t("advanced-search.classroom.forms.days.wednesday"), value: daysEn[2] },
  { label: i18n.t("advanced-search.classroom.forms.days.thursday"), value: daysEn[3] },
  { label: i18n.t("advanced-search.classroom.forms.days.friday"), value: daysEn[4] },
  { label: i18n.t("advanced-search.classroom.forms.days.saturday"), value: daysEn[5] },
  { label: i18n.t("advanced-search.classroom.forms.days.sunday"), value: daysEn[6] },
];

/**
 * Return selected day
 * @param dayEn
 */
export const selectedDayEn = (dayEn: string) => {
  const days = getTranslatedDays();
  let valueEs = "";

  daysEn.forEach((value: string, index: number) => {
    if (value === dayEn) valueEs = days?.[index]?.label;
  });

  return { label: valueEs, value: dayEn };
};

const defaultStartTime = "00:00:00";
const defaultEndTime = "23:59:59";

const todayRange = {
  start: `${dayjs()
    .startOf("day")
    .format("YYYY-MM-DD")} ${defaultStartTime}`,
  end: `${dayjs()
    .endOf("day")
    .format("YYYY-MM-DD")} ${defaultEndTime}`,
};

const last7daysRange = {
  start: `${dayjs()
    .subtract(7, "day")
    .startOf("day")
    .format("YYYY-MM-DD")} ${defaultStartTime}`,
  end: `${dayjs()
    .endOf("day")
    .format("YYYY-MM-DD")} ${defaultEndTime}`,
};

const last30daysRange = {
  start: `${dayjs()
    .subtract(30, "day")
    .startOf("day")
    .format("YYYY-MM-DD")} ${defaultStartTime}`,
  end: `${dayjs()
    .endOf("day")
    .format("YYYY-MM-DD")} ${defaultEndTime}`,
};

const thisMonthRange = {
  start: `${dayjs()
    .startOf("month")
    .format("YYYY-MM-DD")} ${defaultStartTime}`,
  end: `${dayjs()
    .endOf("month")
    .format("YYYY-MM-DD")} ${defaultEndTime}`,
};

const lastMonthRange = {
  start: `${dayjs()
    .subtract(1, "month")
    .startOf("month")
    .format("YYYY-MM-DD")} ${defaultStartTime}`,
  end: `${dayjs()
    .subtract(1, "month")
    .endOf("month")
    .format("YYYY-MM-DD")} ${defaultEndTime}`,
};

/**
 * Formats a local Date to "YYYY-MM-DD" without UTC shift.
 * @param {Date} date - The date to format.
 * @returns {string} The formatted date string.
 */
export const formatLocalDate = (date: Date): string => dayjs(date).format("YYYY-MM-DD");

/**
 * Parses a "YYYY-MM-DD" string as a local date (not UTC).
 * @param {string} dateStr - The date string to parse.
 * @returns {Date} The parsed Date object in local timezone.
 */
export const parseLocalDate = (dateStr: string): Date => dayjs(dateStr).toDate();

export const dateRangeValues = {
  todayRange,
  last7daysRange,
  last30daysRange,
  thisMonthRange,
  lastMonthRange,
};

export const getDateRangeOptions = (): {
  label: string;
  value: "all" | keyof typeof dateRangeValues;
}[] => {
  return [
    { label: i18n.t("selectors.date-range.no-filter"), value: "all" },
    { label: i18n.t("selectors.date-range.today"), value: "todayRange" },
    { label: i18n.t("selectors.date-range.last-7-days"), value: "last7daysRange" },
    { label: i18n.t("selectors.date-range.last-30-days"), value: "last30daysRange" },
    { label: i18n.t("selectors.date-range.this-month"), value: "thisMonthRange" },
    { label: i18n.t("selectors.date-range.last-month"), value: "lastMonthRange" },
  ];
};
